import { Component, Shark, Utils } from "shark-mvc";
import $ from "jquery";

import templateContent from "./contact-finder.html";
import templateAddContactButton from "./add-contact-button.html";
import templateContactFinderModal from "./contact-finder-modal.html";

import agentFilterComponent from "../../_shark_components/agentFilter/agentFilterComponent";
import { clientManager } from "../../_shark_jaws/managers/clientManager";
import Client from "../../_shark_models/Client";
import followUpComponent from "../followUp/followUpComponent";
import leadDetailsView from "../../views/contacts-and-leads/leadDetailsView";

class ContactFinderComponent extends Component {
	constructor() {
		super("contactFinderComponent");

		this.addTemplate("", templateContent);
		this.addTemplate("addContactBtn", templateAddContactButton);
		this.addTemplate("modal", templateContactFinderModal);

		this.set({
			exludedStatusList: [],
			selectedContact: null,
			selectedContactGuid: "",
			selectedContactName: "",
		});

		this.containerId = "";
	}

	beforeLoad () {
		this.reset();
	}

	beforeUnload () {
		this.reset();
	}

	closeModal () {
		$("#contactFinderModal").modal("hide");

		const body = document.querySelector("body");

		if (document.querySelectorAll(".modal.show").length === 0){
			body.classList.remove("modal-open");
			body.style.removeProperty("padding-right");
		}
		else {
			body.classList.add("modal-open");
		}

		this.set({lastSearchContactResul: []});
		
		const contactSearchKeyField = document.querySelector(this.containerId + " #contactSearchKey");
		if (contactSearchKeyField) {
			contactSearchKeyField.value = "";
		}

		const contactSuggestionList = document.querySelector(this.containerId + " #contactSuggestionList");
		if (contactSuggestionList) {
			contactSuggestionList.innerHTML = "";
		}
	}

	contactFinderAddContactBtn_clickHandler (event) {
		const parentForType = event.target.closest(`[data-contact-type]`);

		console.log({parentForType});

		if (parentForType) {
			console.log(parentForType.dataset.contactType);
			this.set({
				requestedContactType: parentForType.dataset.contactType,
			});

			this.openModal();
		}
	}

	contactFinderCancelBtn_clickHandler () {
		this.closeModal();
	}

	contactFinderConfirmClientBtn_clickHandler () {
		clientManager.emit("contactSelected", this.get("selectedContact"));
		this.closeModal();
	}

	contactFinderCreateNewLeadBtn_clickHandler () {
		this.closeModal();

		const contactSearchKeyField = document.querySelector(this.containerId + " #contactSearchKey");
		const searchKey = contactSearchKeyField.value;

		const currProspect = Shark.getInstance(Client, {
			activityStatus: 1,
			enabled: true,
			name:searchKey,
			status: 3
		});
	
		followUpComponent.set("targetItem", currProspect);
	
		Shark.set({
			currProspect,
			isEditingProspect: true,
			isNewProspect: true
		});
	
		Shark.openPage(leadDetailsView);
	}

	contactSearchKey_inputHandler (event) {
		this.containerId = "#contactFinderComponent";
		let contactSearchKeyField = document.querySelector(this.containerId + " #contactSearchKey");
		
		if (!contactSearchKeyField) {
			this.containerId = "#contactSearchModal";
			contactSearchKeyField = document.querySelector(this.containerId + " #contactSearchKey");
		}

		if (contactSearchKeyField) {
			const searchKey = contactSearchKeyField.value;

			if (event.originalEvent.data !== undefined) {
				if (searchKey.length >= 3) {
					document.querySelectorAll(this.containerId + " #contactSearchModalSearchSpinner").forEach(item => item.classList.remove("d-none"));

					const currUser = Shark.get("currUser");
					let userGuid = "any";//currUser.guid;
					
					if (currUser.hasRole("areaManager")) {
						const selectedAgent = agentFilterComponent.getSelectedAgent();
						if (selectedAgent) {
							userGuid = selectedAgent.guid;
						}
					}

					const filters = {
						name: searchKey,
						userGuid,
					};
			
					clientManager.search(filters)
					.then(searchResponse => {
						let searchContactResult = searchResponse.data;
						// const exludedStatusList = this.get("exludedStatusList");
						// console.log({exludedStatusList})
						// if (exludedStatusList) {
						// 	searchContactResult = searchContactResult.filter(item => exludedStatusList.indexOf(item.status) === -1);
						// }

						this.set({
							lastSearchContactResult: searchContactResult,
							searchContactResult,
							selectedContactGuid: "",
						});

						let optionsHTML = "";
						
						if (searchContactResult.length > 0) {
							optionsHTML = searchContactResult.map(item => {
								return `<li class="cursor-pointer list-group-item list-group-item-action p-2 singleContactSuggestionBtn" data-guid="${item.guid}">${item.name} <small style="pointer-events: none;">(${item.__statusLabel}) (${item.__agentFullName})</small></li>`;
							}).join("");
						}
						else {
							optionsHTML = `<li class="list-group-item list-group-item-warning p-2">Nessun risultato per "${searchKey}"</li>`;
						}
						
						document.querySelector(this.containerId + " #contactSuggestionList").classList.remove("d-none");
						document.querySelector(this.containerId + " #contactSuggestionList").innerHTML = `<ul class="list-group">${optionsHTML}</ul>`;
						document.querySelectorAll("#contactSearchModalSearchSpinner").forEach(item => item.classList.add("d-none"));
						document.querySelectorAll("#contactFinderCreateNewLeadBtn").forEach(item => item.classList.remove("disabled"));
					});
				}
				else {
					this.set({lastSearchContactResul: []});
					document.querySelector(this.containerId + " #contactSuggestionList").innerHTML = "";
				}
			}
			else {
				this.set({lastSearchContactResul: []});
				document.querySelector(this.containerId + " #contactSuggestionList").innerHTML = "";
				document.querySelector(this.containerId + " #contactSuggestionList").classList.add("d-none");
				// document.querySelectorAll("#contactSearchModalConfirmBtn").forEach(item => item.disabled = searchKey.length < 3);
			}
		}
	}

	contactSuggestionList_clickHandler (event, data) {
		console.log(event, data);
		if (Object.prototype.hasOwnProperty.call(event.target.dataset, "guid")) {
			const currContact = Utils.safp(this.get("lastSearchContactResult"), "guid", event.target.dataset.guid);

			if (currContact) {
				console.log({currContact});
				const searchField = document.querySelector(this.containerId + " #contactSearchKey");

				if (searchField) {
					searchField.value = currContact.name;
					this.set({
						selectedContact: currContact,
						selectedContactGuid: currContact.guid,
						selectedContactName: currContact.name,
					});
			
					this.set({lastSearchContactResul: []});
					document.querySelector(this.containerId + " #contactSuggestionList").innerHTML = "";
					document.querySelector(this.containerId + " #contactSuggestionList").classList.add("d-none");
				}
			}
		}
	}

	init () {
		Shark.set({
			checkLeadMode: false,
		});
	}

	openModal (mode = "") {
		Shark.set({
			checkLeadMode: mode === "checkLead",
		});

		document.querySelectorAll("#contactFinderCreateNewLeadBtn").forEach(item => item.classList.add("disabled"));
		$("#contactFinderModal").modal("show");
	}

	reset () {
		const contactSearchKey = document.querySelector(this.containerId + " #contactSearchKey");

		if (contactSearchKey) {
			contactSearchKey.value = "";
		}

		this.set({
			exludedStatusList: [],
			selectedContact: null,
			selectedContactGuid: "",
			selectedContactName: "",
		});
	}

	resetInvalidStatus () {
		const contactSearchKey = document.querySelector(this.containerId + " #contactSearchKey");

		if (contactSearchKey) {
			contactSearchKey.classList.remove("is-invalid");
		}
	}

	setAsInvalid () {
		const contactSearchKey = document.querySelector(this.containerId + " #contactSearchKey");

		if (contactSearchKey) {
			contactSearchKey.classList.add("is-invalid");
		}
	}
}

const contactFinderComponent = new ContactFinderComponent();

Shark.registerComponent(contactFinderComponent);

export default contactFinderComponent;
